"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t={trace:()=>{},debug:()=>{},info:()=>{},warn:()=>{},error:()=>{},fatal:()=>{}},e={count:()=>{},gauge:()=>{},distribution:()=>{}};exports.NOOP_LOGGER=t;exports.NOOP_METRICS=e;
//# sourceMappingURL=types.cjs.map
